import * as React from 'react'
import type { SVGProps } from 'react'

interface SVGRProps {
  title?: string
  titleId?: string
}
const SvgColumnsSettingsIcon = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 16 12"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fill="current"
      d="M.006 10.385v-8.77q0-.666.474-1.14A1.56 1.56 0 0 1 1.62 0h12.764q.667 0 1.14.475.475.476.476 1.14v8.77q0 .666-.475 1.14a1.56 1.56 0 0 1-1.14.475H1.62q-.666 0-1.14-.475a1.56 1.56 0 0 1-.474-1.14M1.615 11h3.382V1H1.616a.6.6 0 0 0-.424.192.58.58 0 0 0-.192.424v8.769a.6.6 0 0 0 .192.423.58.58 0 0 0 .423.192m4.383 0h3.998V1H5.998zm4.998 0h3.383a.6.6 0 0 0 .423-.192.58.58 0 0 0 .192-.423v-8.77a.6.6 0 0 0-.192-.423.58.58 0 0 0-.423-.192h-3.383z"
    />
  </svg>
)
export default SvgColumnsSettingsIcon
